import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ModalContext } from 'App';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import TransactionInformation from 'modules/common/components/TransactionInformation';
import * as action from '../action';
import * as c from '../constant';
import VerifyReceipt from '../components/VerifyReceipt';
import CmsContext from '../../../../context/CmsContext';
import ViewSOA from '../components/ViewSOA';
import ViewOR from '../components/ViewOR';

function ApplicationContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  isLoading,
  match,
  taxpayer,
  taxpayerProfile,
  realProperties,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const selectedTransaction = match.params.id;

  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const permissions = getJson('permissions');

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const formatPeriodManila = (data) => {
    return data
      ? data
        .replace('-1', ' - 1st quarter')
        .replace('-2', ' - 2nd quarter')
        .replace('-3', ' - 3rd quarter')
        .replace('-4', ' - 4th quarter')
      : '---';
  };

  const formatPeriod = (data) => {
    return data
      ? data.toString()
        .replace('1', '1st quarter')
        .replace('2', '2nd quarter')
        .replace('3', '3rd quarter')
        .replace('4', '4th quarter')
      : '---';
  };

  const showVerifyReceipt = (status) => {
    return ['WAITING FOR PAYMENT', 'PAID', 'FOR PICK-UP', 'PENDING', 'EXPIRED REFERENCE NUMBER',].includes(
      status
    );
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const onViewSOA = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewSOA
          data={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `View Statement of Account`,
      modalSize: 'modal-xl'
    })
  }

  const onViewOR = e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewOR
          data={transactionInfo}
        />
      ),
      title: `View Original Receipt`,
      modalSize: 'modal-xl'
    })
  }

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-between">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !== '-/format/jpeg/' ?
                          (
                            <img alt="Client Profile" src={_.get(taxpayerProfile, 'photo')} />
                          ) : (
                            getInitials(`${_.get(taxpayer, 'account_name')}`)
                          )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'account_name') || '-'}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mb-3">
                    {_.get(transactionInfo, 'included.module.attributes.or_generated_at') &&
                      Acl(permissions, ['RPTAX VIEW E-OR']) && (
                        <button
                          onClick={onViewOR}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                          type="button"
                        >
                          View OR
                        </button>
                      )}
                    {_.get(transactionInfo, 'included.module.attributes.soa_generated_at') &&
                      !_.get(transactionInfo, 'included.module.attributes.or_generated_at') &&
                      Acl(permissions, ['RPTAX VIEW E-SOA']) && (
                        <button
                          onClick={onViewSOA}
                          className="btn btn-primary cms-bg-color-primary font-weight-bold mr-2"
                          type="button"
                        >
                          View SOA
                        </button>
                      )}
                    {showVerifyReceipt(
                      _.get(transactionInfo, 'attributes.transaction_status')
                    ) &&
                      (
                        <button
                          onClick={handleVerifyReceipt}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                          type="button"
                        >
                          Assess Payment Receipt
                        </button>
                      )}
                  </div>
                  <Tabs>
                    <SideScrollingTab dragToScroll>
                      <TabList>
                        <Tab>Transaction</Tab>
                        <Tab>Account Details</Tab>
                      </TabList>
                    </SideScrollingTab>

                    <TabPanel>
                      <TransactionInformation
                        module="rpts"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="col-12 p-3">
                        {_.get(CMS_VARIABLES, 'ORGANIZATION') === 'Angeles' ? (
                          <>
                            {realProperties.length > 0 && realProperties.map((item) => {
                              return (
                                <React.Fragment key={item.id}>
                                  <table className="application-table table table-borderless">
                                    <tbody>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          ARP No.
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {(
                                              _.get(item, 'attributes.new_arp') || '--'
                                            ).toUpperCase()}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Owner ID
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {(
                                              _.get(item, 'attributes.owner_id') || '--'
                                            ).toUpperCase()}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          PIN
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {(
                                              _.get(item, 'attributes.new_pin') || '--'
                                            ).toUpperCase()}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Period
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {formatPeriod(
                                              _.get(item, 'attributes.period')
                                            )}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Tax Year
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.tax_year')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Tax Due
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.tax_due')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Discount
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.discount')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Penalty
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.penalty_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Amount
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.total_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Basic Tax Due
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.bt_due_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Basic Tax Due per Quarter
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.bt_due_per_qtr_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Basic Discount
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.basic_discount_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Basic Penalty
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.basic_penalty_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Basic Penalty per Quarter
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.basic_penalty_per_qtr_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Basic Total
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.basic_total_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Basic Total Per Quarter
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.basic_total_per_qtr_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Special Education Fund Discount
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_discount_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="400">
                                          Special Education Fund Penalty
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_penalty_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Special Education Fund Penalty Per Quarter
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_penalty_per_qtr_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Special Education Fund Tax Due
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_tax_due_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Special Education Fund Tax Due Per Quarter
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_tax_due_per_qtr_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Special Education Fund Total
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_total_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Special Education Fund Total Per Quarter
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(item, 'attributes.sef_total_per_qtr_human')}
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="text-dark" width="250">
                                          Is Posted
                                        </td>
                                        <td className="text-dark" width="1">
                                          :
                                        </td>
                                        <td>
                                          <b>
                                            {_.get(
                                              item,
                                              'attributes.is_posted'
                                            )
                                              ? 'YES'
                                              : 'NO'}
                                          </b>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </React.Fragment>
                              )
                            })}
                          </>
                        )
                          : (
                            <table className="transaction-table table table-borderless ">
                              <tbody>
                                <tr>
                                  <td className="text-dark" width="250">
                                    Account Name
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td>
                                    <b>
                                      {(
                                        _.get(taxpayer, 'account_name') || '--'
                                      ).toUpperCase()}
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-dark" width="250">
                                    TDN
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td>
                                    <b>
                                      {(
                                        _.get(taxpayer, 'tdn') || '--'
                                      ).toUpperCase()}
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-dark" width="250">
                                    {_.get(taxpayer, 'or_no') &&
                                      _.get(CMS_COMPONENTS, 'RPTAX_HAS_OR')
                                      ? 'OR Number'
                                      : 'PIN'}
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td>
                                    <b>
                                      {(_.get(taxpayer, 'or_no') &&
                                        _.get(CMS_COMPONENTS, 'RPTAX_HAS_OR')
                                        ? _.get(taxpayer, 'or_no')
                                        : _.get(taxpayer, 'pin') || '--'
                                      ).toUpperCase()}
                                    </b>
                                  </td>
                                </tr>
                                {
                                  _.get(CMS_COMPONENTS, 'RPTAX_HAS_OR') && (
                                    <tr>
                                      <td className="text-dark" width="250">
                                        Bill Number
                                      </td>
                                      <td className="text-dark" width="1">
                                        :
                                      </td>
                                      <td>
                                        <b>
                                          {formatPeriodManila(
                                            _.get(taxpayer, 'bill_no')
                                          )}
                                        </b>
                                      </td>
                                    </tr>
                                  )
                                }

                                <tr>
                                  <td className="text-dark" width="250">
                                    From
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td>
                                    <b>
                                      {formatPeriodManila(
                                        _.get(taxpayer, 'payment_from')
                                      )}
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-dark" width="250">
                                    To
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td>
                                    <b>
                                      {formatPeriodManila(_.get(taxpayer, 'payment_to'))}
                                    </b>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-dark" width="250">
                                    Date Processed
                                  </td>
                                  <td className="text-dark" width="1">
                                    :
                                  </td>
                                  <td>
                                    <b>
                                      {_.get(taxpayer, 'date_processed')
                                        ? moment(
                                          `${_.get(taxpayer, 'date_processed')}`
                                        ).format('MMM DD, YYYY')
                                        : '--'}
                                    </b>
                                  </td>
                                </tr>
                                {_.get(CMS_COMPONENTS, "RPTAX_HAS_OR") ? "" : (
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Expiration Date
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'expiration_date')
                                          ? moment(
                                            `${_.get(taxpayer, 'expiration_date')}`
                                          ).format('MMM DD, YYYY')
                                          : '--'}
                                      </b>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          )
                        }
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ApplicationContent.propTypes = {
  // selectedTransaction: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  realProperties: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
      business_establishments:
        _.get(
          api,
          `${c.SHOW_TRANSACTION}.item.included.businessEstablishments`
        ) || [],
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  realProperties: _.get(api, `${c.SHOW_TRANSACTION}.item.included.realProperties`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApplicationContent);
